<template>
  <v-container fluid>
    <v-layout justify-start>
      <v-card width="80vw" >
        <v-flex lg12 pa-5 >
          <v-layout>
            <v-layout>
              <v-flex >
                <h2 class="primary--text text-uppercase">
                  {{localization.list.title}}
                </h2>
              </v-flex>
            </v-layout>
            <v-layout wrap align-center justify-end pb-4>
              <v-flex xs8 sm8 md8 lg8 justify-end class="text-end">      
                <v-btn
                  style="margin-right: 10px"
                  color="primary" 
                  @click="dialogImportar = true"
                  v-if="tubos"
                >
                  IMPORTAR
                </v-btn>
                <v-btn 
                  style="margin-right: 10px"
                  color="primary"
                  @click="crearPromocion = true"
                  :disabled="promocionSelectedId ? true : false"   
                >
                  {{localization.selectSociedad.addButton}}
                </v-btn>
                <v-btn   
                  color="primary"
                  @click="editarPromocion = true"
                  :disabled="promocionSelectedId ? false : true"   
                >
                  {{localization.selectSociedad.editarButton}}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-layout>
          <v-layout wrap justify-end>
            <v-flex xs4 sm4 md4 lg4 mb-4 mt-n4>
              <v-text-field
                v-model="search" id="search"
                append-icon="mdi-magnify"
                label="Filtrar"
                hide-details>
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-divider class="divider_subtitle"></v-divider>
          <v-data-table
            style="display: inline-block !important; width:77.8vw !important"
            :search="search"
            :headers="headers"
            :items="promociones"
            sort-by="code"
            class="elevation-1"
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.value" @click="selectItem(item)" :style="{'background-color': promocionSelectedId === item.id ? 'lightgray' : ''}">
                  <td style="max-width: 100px" class="text-xs-left">{{ item.code }}</td>
                  <td style="max-width: 200px" class="text-xs-left">{{ item.name }}</td>
                  <td style="max-width: 200px" class="text-xs-left">{{ item.codigoSociedad != null && item.denominacion != null ? item.codigoSociedad + '-' + item.denominacion : ''}}</td><!-- {{ item.codigoSociedad }} - {{item.denominacion}} -->
                  <td style="max-width: 200px" class="text-xs-left">{{ item.address === '' || item.address === null ? '' : item.address}}
                    {{ item.poltalCode === '' || item.poltalCode === null ? '' : ', ' + item.poltalCode}}
                    {{ item.city  === '' || item.city === null ? '' : ', ' +  item.city}}{{ item.region === '' || item.region === null ? '' : ', ' + item.region}} {{ item.country === '' || item.country === null? '' : ', ' + item.country  }}</td>
                  <td style="max-width: 200px" class="text-xs-left">{{ item.sector }}</td>
                  <td class="text-xs-center">
                    <v-flex row justify-center>
                      <v-icon class="iconSize" small @click="openDelete(item.id, item.code)">delete</v-icon>
                    </v-flex>
                  </td>
                </tr>
              </tbody>
              <ConfirmDialog @close="deleteItem()" :text="textDialog"
              @cancel="dialog = false" :dialogFlag="dialog" />
            </template>
          </v-data-table>
        </v-flex>
      </v-card>
      <FormImportar v-model="dialogImportar" id="dialogImportar" v-if="dialogImportar" :tipo="'promociones'" @reload="refrescarImportar()" @input="refrescarImportar()"/>
    </v-layout>
    <v-fade-transition>
      <custom-dialog 
        v-if="crearPromocion === true" 
        v-model="crearPromocion" id="crearPromocion"
      >
      <PopUpNuevaPromocion :editar="false" @aceptar="addPromocion($event)"/>
      </custom-dialog>
      <custom-dialog 
        v-if="editarPromocion === true && crearPromocion === false" 
        v-model="editarPromocion" id="editarPromocion"
      >
      <PopUpNuevaPromocion :editar="editarPromocion" :item="promocionPopUpEditar" @aceptar="editPromocion($event)"/>
      </custom-dialog>
    </v-fade-transition>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ConfirmDialog from '../../custom/confirmDialog'
import PopUpNuevaPromocion from './PopUpNuevaPromocion'
import FormImportar from '../../incidencias/formularios/gestion/formImportarPromociones'

export default {
  components: {
    ConfirmDialog,
    PopUpNuevaPromocion,
    FormImportar,
  },
  data () {
    return {
      dialog: false,
      itemToDeleteId: null,
      itemToDeleteCode: '',
      textDialog: null,
      promocionPopUpEditar: {},
      crearPromocion: false,
      editarPromocion: false,
      promocionSelectedId: null,
      search: '',
      dialogImportar: false,
      tubos: true
    }
  },
  computed: {
    ...mapGetters({
      /* tubos: 'getTubos' */
    }),
    localization () {
      return this.$t('gestion.promociones')
    },
    headers () {
      return [
        { text: this.localization.list.codigo, value: 'code', width: '10%', sortable: true, align: 'left' },
        { text: this.localization.list.descripcion, value: 'name', width: '10%', sortable: true, align: 'left' },
        { text: this.localization.list.sociedad, value: 'codigoSociedad', sortable: true, align: 'left' },
        { text: this.localization.list.direccion, value: 'address', sortable: true, align: 'left' },
        { text: this.localization.list.sector, value: 'sector', sortable: true, align: 'left' },
        { text: '', value: '', align: 'center' }
      ]
    },
    promociones() {
      if (this.$store.state.gestion.promotions) {
        return this.$store.state.gestion.promotions.map(x => {
          return {
            ...x,
            nombreCompleto: x.code + ' - ' + x.name
          }
        })
      }
      return []
    },
    seccion(){
      if(this.$store.state.gestion.componenteSeleccionado){
        return this.$store.state.gestion.componenteSeleccionado
      }
      return ''
    }
  },
  async created(){
    this.loader = this.$loading.show({
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          onCancel: this.onCancel
        })
        await this.getPromotions()
        this.loader.hide()
  },
  mounted () {

  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getPromotions: 'gestion/getPromotions',
      addPromotion: 'gestion/addPromotion',
      updatePromotion: 'gestion/updatePromotion',
      deletePromotion: 'gestion/deletePromotion',
      getInmuebles: 'gestion/getInmuebles',
    }),
    async openDelete (id, code) {
      this.textDialog = '¿Está seguro que desea eliminar el elemento seleccionado?'
      this.openDialog(id, code)
    },
    openDialog (itemId, itemCode) {
      this.dialog = true
      this.itemToDeleteId = itemId
      this.itemToDeleteCode = itemCode
      
    },
    async deleteItem () {
      this.dialog = false
      this.loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel
      })
      try {
        let values = {
          id: this.itemToDeleteId,
          code: this.itemToDeleteCode
        }
        await this.deletePromotion(values)
        this.promocionSelectedId = null
        await this.getPromotions(this.promocionSelectedId)
        this.loader.hide()
        this.addAlert({texto: this.$t('baja_correcta'), color: 'success'})
      } catch (error) {
        this.addAlert({texto: error.message, color: 'error'})
        this.loader.hide()
      }
    },
    selectItem (item) {
      if (!this.promocionSelectedId || this.promocionSelectedId !== item.id) {
        this.promocionSelectedId = item.id
      } else {
        if(!this.dialog){this.promocionSelectedId = null}
        
      }
    },
    async addPromocion(values){
      this.loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel
      })
      try{
        await this.addPromotion(values)
        await this.getPromotions()
        this.loader.hide()
        this.addAlert({texto: this.$t('alta_correcta'), color: 'success'})
      }
      catch (error) {
        this.loader.hide()
        this.addAlert({texto: error.message, color: 'error'})
      }
    },
    async editPromocion (ev) {
      this.loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel
      })
      try {
        ev.id = this.promocionSelectedId
        await this.updatePromotion(ev)
        await this.getPromotions()
        this.editarPromocion = false
        this.promocionPopUpEditar = this.promociones.find(x=> x.id === this.promocionSelectedId)
        this.loader.hide()
        this.addAlert({texto: this.$t('edicion_correcta'), color: 'success'})
        this.getInmuebles()
      } catch (error) {
        this.loader.hide()
        this.addAlert({texto: error.message, color: 'error'})
      }
    },
    async refrescarImportar(){
      await this.getInmuebles()
      await this.getPromotions()
    }
  },
  watch: {
    promocionSelectedId() {
      this.promocionPopUpEditar = this.promociones.find(x=> x.id === this.promocionSelectedId)
    },
    seccion (){
      this.promocionSelectedId = null
      this.search = ''
    } 
  }
}
</script>

